var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFolderLight = function SvgIconFolderLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_folder_light_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.7c0-2.607 2.092-4.7 4.7-4.7h4.1c1.031 0 2.188.374 3.004 1.055l.004.003L25.5 16H34.5c2.608 0 4.7 2.093 4.7 4.7v11.8c0 2.608-2.093 4.7-4.7 4.7H13.7A4.685 4.685 0 0 1 9 32.5V15.7Zm4.7-2.5a2.485 2.485 0 0 0-2.5 2.5v16.8c0 1.392 1.107 2.5 2.5 2.5h20.8c1.392 0 2.5-1.108 2.5-2.5V20.7c0-1.392-1.108-2.5-2.5-2.5h-9.4a1.1 1.1 0 0 1-.708-.258l-4.996-4.197-.002-.001c-.383-.319-1.026-.544-1.594-.544h-4.1Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_folder_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 11)",
    d: "M0 0h30.2v26.2H0z"
  })))));
};
export default SvgIconFolderLight;